import { Api } from 'models/services/api';
import { ReadHeadquartersQuery } from 'models/services/graphql';

import { HeadquartersCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query ReadHeadquarters($nextToken: String) {
    ${ReadHeadquartersQuery}
  }
`;

type ResponseData = {
  data: {
    readHeadquarters: HeadquartersCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: HeadquartersCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readHeadquarters;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
